import React from "react";

export const InfoCard = ({
  title,
  subtitle,
  imgSrc,
  className = "",
  textClassName = "",
}) => {
  return (
    <div
      className={`
        w-full h-full
        rounded-[24px] lg:rounded-[32px]
        overflow-hidden
        flex flex-col
        justify-between
        ${className}
     `}
    >
      <div className="px-5 pt-6 sm:px-6">
        <div
          className={`${textClassName} text-[32px] xl:text-[42px] leading-[36px] xl:leading-[52px] xl:tracking-[0.02em]`}
        >
          {title}
        </div>
        <div className="mt-3 min-h-0 text-sm text-grey-800 sm:min-h-[88px] md:text-base">
          {subtitle}
        </div>
      </div>

      <img src={imgSrc} alt="card" className="block w-full -mb-1" />
    </div>
  );
};
